import { Col, Form, Row } from "antd";
import { MazakaForm } from "apps/Common/MazakaForm";
import MazakaInputNumber from "apps/Common/MazakaInputNumber";
import { MazakaSelect } from "apps/Common/MazakaSelect";
import useMazakaForm from "hooks/useMazakaForm";
import { useEffect, useState } from "react";
import CreditList from "./CreditList";
import { useSearchParams } from "react-router-dom";
import { useGetAdvertDetails } from "apps/RealState/Details/ServerSideStates";
import { MazakaButton } from "apps/Common/MazakaButton";

const CreditForm = () => {
  const [form] = Form.useForm();
  const { formActions, mazakaForm } = useMazakaForm(form);
  const [searchParams] = useSearchParams();
          const advertId = searchParams.get("id");
          const advertDetails = useGetAdvertDetails(advertId);
          const advertData = advertDetails?.data?.data
  const [data, setData] = useState({
    creditAmount: 0,
    termMonths: 0,
  });

  function parseValue(value:number|string) {
    return typeof value === "string" ? parseFloat(value.replace(/,/g, '')) : value;
}
  useEffect(()=>{
    if(advertData)
    {
      form.setFieldValue("creditAmount",advertData?.price)
    }
  },[advertDetails?.data])
  const handleOnFinish = () => {
   mazakaForm.setLoading()
    let formValues = form.getFieldsValue();
   
    formValues["creditAmount"] = parseValue(
      formValues["creditAmount"] || 0
    );

    setData(formValues);
    mazakaForm.setSuccess(2000, () => "İşlem Başarılı");
  };
  const termMonths = [
    { label: "4 Ay", value: 4 },
    { label: "8  Ay", value: 8 },
    { label: "12  Ay", value: 12 },
    { label: "16  Ay", value: 16 },
    { label: "20  Ay", value: 20 },
    { label: "24  Ay", value: 24 },
    { label: "28  Ay", value: 28 },
    { label: "32  Ay", value: 32 },
    { label: "36  Ay", value: 36 },
    { label: "40  Ay", value: 40 },
    { label: "44  Ay", value: 44 },
    { label: "48  Ay", value: 48 },
    ...(advertData.type===0?
      Array.from({ length: (120 - 52) / 4 + 1 }, (_, i) => {
        const value = 52 + i * 4;
        return { label: `${value} Ay`, value };
      })
    :[])
  ];

  return (
    <>
      <Col span={24} className="">
        <Row 
        gutter={[
          { xs: 0, md: 0 ,lg:0,xxl:0},
          { xs: 10, md: 20,lg:30,xxl:40 },
        ]}
        
        >
          <Col xs={24}>
            <MazakaForm
             submitButtonVisible={false}
              form={form}
              onFinish={handleOnFinish}
              submitButtonXPosition="left"
               lg={8} xl={6} xxl={6}
              {...formActions}
            >
              <Row gutter={[0,20]}>
                <MazakaInputNumber
                  xs={24}  
                  size="large"
                  formattedInputNumber={true}
                  form={form}
                  name={"creditAmount"}
                  label={"Miktar"}
                  className="!m-0"
                  placeholder={"Miktar"}
                  rules={[{ required: true, message: "" }]}
                />
                <MazakaSelect
                size="large"
                  xs={24} 
                  label="Vade"
                  placeholder="Vade"
                  name={"termMonths"}
                  options={termMonths}
                  rules={[{ required: true, message: "" }]}
                />
                 <Col xs={24}>
                                      <MazakaButton
                                        className="!p-4 !bg-[#FFC502] !text-black"
                                        htmlType="submit"
                                        block
                                        processType={formActions.submitProcessType}
                                      >
                                        Hesapla
                                      </MazakaButton>
                                    </Col>
              </Row>
            </MazakaForm>
          </Col>
          {data.creditAmount!==0 && data.termMonths!==0 && (
            <>
              <Col xs={34}>
                <CreditList data={data} />
              </Col>
            </>
          )}
        </Row>
      </Col>
    </>
  );
};

export default CreditForm;
